__turbopack_context__.v({
  "activity": "room-controls-module__hhNKjG__activity",
  "archivedThreads": "room-controls-module__hhNKjG__archivedThreads",
  "body": "room-controls-module__hhNKjG__body",
  "check": "room-controls-module__hhNKjG__check",
  "columns": "room-controls-module__hhNKjG__columns",
  "confirm": "room-controls-module__hhNKjG__confirm",
  "disclosure": "room-controls-module__hhNKjG__disclosure",
  "drawer": "room-controls-module__hhNKjG__drawer",
  "empty": "room-controls-module__hhNKjG__empty",
  "feedback": "room-controls-module__hhNKjG__feedback",
  "fileActions": "room-controls-module__hhNKjG__fileActions",
  "fileList": "room-controls-module__hhNKjG__fileList",
  "fileThread": "room-controls-module__hhNKjG__fileThread",
  "fileTitle": "room-controls-module__hhNKjG__fileTitle",
  "form": "room-controls-module__hhNKjG__form",
  "header": "room-controls-module__hhNKjG__header",
  "hint": "room-controls-module__hhNKjG__hint",
  "preview": "room-controls-module__hhNKjG__preview",
  "primary": "room-controls-module__hhNKjG__primary",
  "secondary": "room-controls-module__hhNKjG__secondary",
  "sections": "room-controls-module__hhNKjG__sections",
  "threadForm": "room-controls-module__hhNKjG__threadForm",
  "threadMenu": "room-controls-module__hhNKjG__threadMenu",
  "threadSwitcher": "room-controls-module__hhNKjG__threadSwitcher",
  "upload": "room-controls-module__hhNKjG__upload",
  "warning": "room-controls-module__hhNKjG__warning",
});
